import { useContext } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { postRequest, putRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import {
  DeviceContext,
  SET_SELECTED_DEVICES_DATA,
  SET_SHOW_HIDE_DEVICES_POPUP,
  UPDATE_CHANGE_DEVICES_DATA,
} from '../context/context'
import TextArea from '../../../common/TextArea'

const DeviceForm = ({ onDataSave }) => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(DeviceContext)

  const saveDevicesData = async (e) => {
    const formData = new FormData(e.target)
    formData.append('vehicle', vehicle)

    if (state?.selectedObject?.id) {
      let res = await putRequest(
        `/api/devices/${state?.selectedObject?.id}/?vehicle=${vehicle}`,
        formData
      )
      onDataSave(res?.status, 'Data Successfully Saved')
      if (res?.status) {
        dispatch({
          type: UPDATE_CHANGE_DEVICES_DATA,
          data: state?.selectedObject,
        })
        closePopUp()
      }
    } else {
      let res = await postRequest(`/api/devices/`, formData)
      onDataSave(res?.status, 'Data Successfully Saved')
      if (res?.status) {
        closePopUp()
      }
    }
  }

  const closePopUp = () => {
    dispatch({
      type: SET_SHOW_HIDE_DEVICES_POPUP,
      data: false,
    })
  }

  return (
    <Modal
      onClose={() => {
        closePopUp()
      }}
      show={state?.showDeviceFormPopup}
    >
      <ModalHeader className={'text-white'}>Device's</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveDevicesData(e)
          }}
        >
          <div className="flex">
            <InputText
              name="name"
              value={state?.selectedObject?.name}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_DEVICES_DATA,
                  data: {
                    ...state?.selectedObject,
                    name: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Name'}
              type="text"
            />
            <InputText
              name="category"
              value={state?.selectedObject?.category}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_DEVICES_DATA,
                  data: {
                    ...state?.selectedObject,
                    category: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Category'}
              type="text"
              isRequired={false}
            />
          </div>
          <div className="flex w-full text-white">
            <TextArea
              name="description"
              value={state?.selectedObject?.description}
              onChange={(value) => {
                dispatch({
                  type: SET_SELECTED_DEVICES_DATA,
                  data: {
                    ...state?.selectedObject,
                    description: value,
                  },
                  showFormPopup: true,
                })
              }}
              label={'Description'}
              type="text"
              isRequired={false}
              className="w-full"
            />
          </div>
          <div className="flex justify-between">
            <div className="w-full">
              <InputText
                name="alias"
                value={state?.selectedObject?.alias?.value}
                onChange={(value) => {
                  dispatch({
                    type: SET_SELECTED_DEVICES_DATA,
                    data: {
                      ...state?.selectedObject,
                      alias: {
                        ...state?.selectedObject?.alias,
                        value: value,
                      },
                    },
                    showFormPopup: true,
                  })
                }}
                label={'Device Alias'}
                type="text"
                isRequired={false}
              />
            </div>
          </div>
          <div className="flex justify-end">
            <div className="w-1/3 px-2 mt-5">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end pr-2`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save Devices'}
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default DeviceForm
